const VARIANTE_DEFAULT = 'RELIGIOSO';

function slugFromTipoNombre(nombre) {
  if (nombre == null) return '';
  const s = String(nombre).trim().toLowerCase();
  if (!s) return '';
  return s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '')
    .slice(0, 32);
}

function entitySlugFallback(perfilVariante) {
  const v = perfilVariante || VARIANTE_DEFAULT;
  if (v === 'AYUNTAMIENTO') return 'ayuntamiento';
  if (v === 'ASOCIACION_CULTURAL') return 'asociacioncultural';
  if (v === 'OTRO') return 'entidad';
  return 'hermandad';
}

function tipoNombreMin(tipoEntidad) {
  if (tipoEntidad?.nombre == null) return '';
  const s = String(tipoEntidad.nombre).trim().toLowerCase();
  return s || '';
}

/**
 * Placeholder del email de contacto público según tipo de entidad y variante de perfil.
 * @param {{ perfilVariante?: string; tipoEntidad?: { nombre?: string } | null }} p
 */
export function getCofradiaContactoEmailPlaceholder({ perfilVariante, tipoEntidad }) {
  const fromTipo = slugFromTipoNombre(tipoEntidad?.nombre);
  const slug = fromTipo || entitySlugFallback(perfilVariante);
  return `contacto@${slug}.ejemplo`;
}

/**
 * Placeholder tipo @tu_entidad para Instagram / TikTok.
 * @param {{ perfilVariante?: string; tipoEntidad?: { nombre?: string } | null }} p
 */
export function getCofradiaRedSocialHandlePlaceholder({ perfilVariante, tipoEntidad }) {
  const slug = slugFromTipoNombre(tipoEntidad?.nombre) || entitySlugFallback(perfilVariante);
  return `@tu_${slug}`;
}

/**
 * Primera viñeta del recuadro «Consejos para mejores fotos» (galería).
 * @param {{ perfilVariante?: string; tipoEntidad?: { nombre?: string } | null }} p
 */
export function getCofradiaGaleriaFotosConsejoLinea1({ perfilVariante, tipoEntidad }) {
  const v = perfilVariante || VARIANTE_DEFAULT;
  const tipoMin = tipoNombreMin(tipoEntidad);

  if (v === 'AYUNTAMIENTO') {
    return '• Sube fotos del municipio: plenos, eventos culturales, fiestas locales y espacios emblemáticos';
  }
  if (v === 'ASOCIACION_CULTURAL') {
    const suj = tipoMin || 'asociación';
    return `• Sube fotos de tu ${suj}: conciertos, talleres, sede o local y actividades en público`;
  }
  if (v === 'OTRO') {
    const suj = tipoMin || 'entidad';
    return `• Sube fotos de tu ${suj}: actividades, instalaciones y momentos representativos`;
  }
  if (tipoMin) {
    return `• Sube fotos de tu ${tipoMin}: pasos, cultos, eventos y sede canónica`;
  }
  return '• Sube fotos de tu cofradía o hermandad: pasos, cultos, eventos y sede canónica';
}

/**
 * Placeholder del título al añadir un vídeo de YouTube al perfil.
 * @param {{ perfilVariante?: string; tipoEntidad?: { nombre?: string } | null }} p
 */
export function getCofradiaYoutubeTituloPlaceholder({ perfilVariante, tipoEntidad }) {
  const v = perfilVariante || VARIANTE_DEFAULT;
  const tipoMin = tipoNombreMin(tipoEntidad);

  if (v === 'AYUNTAMIENTO') {
    return 'Ej: Concierto municipal, pregón de fiestas o acto institucional 2024';
  }
  if (v === 'ASOCIACION_CULTURAL') {
    return 'Ej: Concierto solidario, presentación de temporada o acto cultural 2024';
  }
  if (v === 'OTRO') {
    return tipoMin
      ? `Ej: Acto o actividad destacada de tu ${tipoMin} (2024)`
      : 'Ej: Actividad o proyecto representativo (2024)';
  }
  return tipoMin
    ? `Ej: Procesión o culto destacado de tu ${tipoMin} (2024)`
    : 'Ej: Procesión de Semana Santa, culto o acto litúrgico 2024';
}
